import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';

export interface ClaudeConnectRequest {
    clientName: string;
    redirectHost: string;
    userEmail: string;
}

export interface ClaudeConnection {
    grantId: string;
    clientName: string;
    createdAt: string;
    expiresAt: string;
}

/** The logged-in side of the Claude connector: approving a connection and managing existing ones. */
@Injectable({ providedIn: 'root' })
export class ClaudeConnectService {
    private httpOptions = {};

    constructor(private httpClient: HttpClient, authenticationService: AuthenticationService) {
        this.httpOptions = authenticationService.getHeaders();
    }

    getRequest(id: string): Observable<ClaudeConnectRequest> {
        return this.httpClient.get<ClaudeConnectRequest>(`${environment.baseUrl}/mcp-connect/requests/${encodeURIComponent(id)}`, this.httpOptions);
    }

    approve(id: string): Observable<{ redirectUrl: string }> {
        return this.httpClient.post<{ redirectUrl: string }>(`${environment.baseUrl}/mcp-connect/requests/${encodeURIComponent(id)}/approve`, {}, this.httpOptions);
    }

    deny(id: string): Observable<{ redirectUrl: string }> {
        return this.httpClient.post<{ redirectUrl: string }>(`${environment.baseUrl}/mcp-connect/requests/${encodeURIComponent(id)}/deny`, {}, this.httpOptions);
    }

    getConnections(): Observable<ClaudeConnection[]> {
        return this.httpClient.get<ClaudeConnection[]>(`${environment.baseUrl}/mcp-connect/connections`, this.httpOptions);
    }

    revoke(grantId: string): Observable<void> {
        return this.httpClient.delete<void>(`${environment.baseUrl}/mcp-connect/connections/${encodeURIComponent(grantId)}`, this.httpOptions);
    }
}
